import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import CheckmarxConfigListing from './CheckmarxConfigListing'
import CheckmarxCredentialsForm from './CheckmarxCredentialsForm'

export default function CheckmarxPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CheckmarxCredentialsForm}
            PullConfigListingView={CheckmarxConfigListing}
        />
    )
}
